import React from 'react';

import { ChartsData } from '../DiagramComponent';
import { StyledLegendIcon, StyledLegendItemWrapper, StyledLegendText, StyledLegendWrapper } from './styled';
import { countPercent, formatDeviceName } from './utils';

type Props = {
  data: ChartsData[];
  total: number;
};

const LegendForChart = ({ data, total }: Props): JSX.Element => (
  <StyledLegendWrapper data-testid="legendWrapper">
    {data.map(
      (entry) =>
        entry.value !== 0 && (
          <StyledLegendItemWrapper key={entry.name}>
            <StyledLegendIcon $color={entry.color}></StyledLegendIcon>
            <StyledLegendText>{`${formatDeviceName(entry.name)} (${countPercent(
              total,
              entry.value
            )})`}</StyledLegendText>
          </StyledLegendItemWrapper>
        )
    )}
  </StyledLegendWrapper>
);

export default LegendForChart;
